import { Button, FormControl, FormLabel, Input, Box } from '@chakra-ui/react';
import React, { useCallback, useState } from 'react';
import ConversationArea from '../../classes/ConversationArea';
import useCoveyAppState from '../../hooks/useCoveyAppState';
import useMaybeVideo from '../../hooks/useMaybeVideo';

interface Props {
  conversation: ConversationArea;
  leaderId: string;
}

export default function DictatorForm({ conversation, leaderId }: Props): JSX.Element {

  const { myPlayerID, socket } = useCoveyAppState();

  const [isTyping, setIsTyping] = useState<boolean>(false); // update car wen typing
  const video = useMaybeVideo();
  if (isTyping) {
    video?.pauseGame();
  };


  const [tempMedia, setTempMedia] = useState<string | undefined>("");

  const handleSubmission = useCallback((event) => {
    event.preventDefault();
    setIsTyping(false);
    video?.unPauseGame();
    const conversationCopy = conversation.copy();
    if (tempMedia) {
      conversationCopy.media.push(tempMedia);
      if (socket) socket.emit('setMedia', conversationCopy.toServerConversationArea());
    }
    // where setMedia will give all the players the correct media ?
  }, [conversation, tempMedia, socket, video]);

  const handleSkip = useCallback((event) => {
    event.preventDefault();
    setIsTyping(false);
    video?.unPauseGame();
    const conversationCopy = conversation.copy();
    if (conversationCopy.media.length > 0) {
      conversationCopy.media.splice(0, 1);
      if (socket) socket.emit('setMedia', conversationCopy.toServerConversationArea());
    }
    // where setMedia will give all the players the correct media ?
  }, [conversation, socket, video]);

  if (myPlayerID === leaderId) {
    return <Box mb='8' mt='8'>
      <form
        onSubmit={ev => {
          handleSubmission(ev);
        }}>
        <FormControl>
          <FormLabel htmlFor='topic' ml='1'>Add a link to the queue</FormLabel>
          <Input
            id='media'
            placeholder='Set the media to Play'
            name='media'
            value={tempMedia}
            onChange={(e) => { setTempMedia(e.target.value); setIsTyping(true); }}
            mb='2'
          />
        </FormControl>
        <Button
          type='submit'
          colorScheme='blue'
          mr={3}
          onClick={handleSubmission}>
          Submit
        </Button>
        <Button
          colorScheme='red'
          mr={3}
          onClick={handleSkip}>
          Skip
        </Button>
      </form>
    </Box>;
  }
  return <></>;
}